// filepath: /Users/thomasgaggl/Softline/development/nx/libs/framework/core/src/lib/date/functions/get/start-of-month.ts
import { isIsoDate } from '../../validation/is-iso-date.function';
import { isIsoDateTime } from '../../validation/is-iso-date-time.function';
import { isIsoDateTimeTz } from '../../validation/is-iso-date-time-tz.function';
import { getTimeOffset } from '../../get/get-time-offset.function';
import { IsoDate, IsoDateTime, IsoDateTimeTz } from '../../../types/iso-date';
import { deconstructDate } from '../../helper/deconstruct-date.function';
import { getLastDayOfMonth } from '../../helper/last-day-of-month.function';
import { constructDate } from '../../helper/construct-date.function';

/**
 * Returns the first day/instant of the month for a given ISO input.
 * - For date-only (YYYY-MM-DD) -> returns 'YYYY-MM-01'
 * - For date-time without tz -> returns 'YYYY-MM-01T00:00:00.000'
 * - For date-time with tz -> returns 'YYYY-MM-01T00:00:00.000Z|±HH:MM'
 */
export function startOfMonth<T extends IsoDate | IsoDateTime | IsoDateTimeTz>(input: T): T {
  const deconstructed = deconstructDate(input);
  if (deconstructed._type !== 'date' && deconstructed._type !== 'dateTime' && deconstructed._type !== 'dateTimeTz') {
    throw new Error('startOfMonth: invalid ISO date/time string');
  }
  deconstructed.day = 1
  if (deconstructed._type !== 'date') {
    deconstructed.hours = 0;
    deconstructed.minutes = 0;
    deconstructed.seconds = 0;
    deconstructed.milliseconds = 0;
  }
  return constructDate(deconstructed) as unknown as T;
}

// Backwards-compatible alias
export { startOfMonth as startOfMonthFunction };
